import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { BillOfMaterialService } from 'pages/quote-setup/bill-of-material/service';
import { formatTableLink } from 'resources/utility';

@inject(BillOfMaterialService, Router)
export class BillOfMaterial {
    constructor(billOfMaterialService, router) {
        this.billOfMaterialService = billOfMaterialService;
        this.router = router;

        this.columns = [
            { dataField: 'number', sortOrder: 'asc', caption: 'Part Number', cellTemplate: (container, options) => formatTableLink({ container, containerOptions: options, callback: this.edit }) },
            { dataField: 'name' },
            { dataField: 'partType', allowFiltering: false },
            { dataField: 'location', caption: 'Purchase Type / Mfg Location', allowFiltering: false }
        ];
    }

    edit = (data) => {
        this.router.navigate(`quote-setup/bill-of-material/${data.partId}`);
    };
}